













































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Ref, Vue, Watch } from 'vue-property-decorator'
import _ from 'lodash'
import moment from 'moment'
import Component from 'vue-class-component'
import $ from 'jquery'
import '../../../public/ueditor/ueditor.config.js'
import './../../../public/ueditor/ueditor.all.js'
import '../../../public/ueditor/lang/zh-cn/zh-cn.js'
import VueUeditorWrap from 'vue-ueditor-wrap'
import { ElSlider } from 'element-ui/types/slider'
import { monitorEventLoopDelay } from 'perf_hooks'
import {
  gettableinfo,
  updateinfo,
  saveOrupdateContent,
  updateTopicResult,
  updateTopicFunding,
  uploadzsxg,
  updateuploadfile,
  getfiles,
  removefile,
  getAccessoryList,
  updatetopicfile,
  getReport,
  createReport,
  updateStatus
} from '@/api/ladder'

@Component({
  name: 'demo',
  components: { VueUeditorWrap }
})
export default class extends Vue {
  public typeidentifier = 1;
  public topicid: any = '';
  public id = '';
  public iswatch = true;
  public ktloading = false;
  public ktloadingtitle = '';
  public iseditys = false;
  public subbtn = 'info';
  public subisuse = true;
  public loading = false;
  public uploadid = '';
  public baseurl = '';
  public uploadloading = false;
  public uploadktfj = false;

  public activeName = '数据表';
  public dataForm: any = {
    topicname: '', // 课题名称
    topictype: '', // 课题种类
    headname: '', // 负责人姓名
    birthday: '', // 出生日期
    educationbg: '', // 学历
    positiontitle: '', // 职务职称
    department: '', // 所在部门
    phone: '', // 联系电话

    profitissue: '', // 发表论文
    profitpublish: '', // 出版专著
    profitsoft: '', // 软    件(套)
    profitteaching: '', // 编写教材
    profitpatent: '', // 获得专利
    profitac: '', // 会议交流
    profitreport: '', // 报告
    profitother: '', // 其他
    profitdesc: '', // 其他说明
    problemtime: '', // 启动时间

    topicLadderJobInfoDelIds: [], // 课题组成员及在课题研究中承担的主要工作列表删除的id集合
    topicLadderResultInfoDelIds: [] // 课题成果目录中要删除的id集合
  };
  // 学历数组
  public learnlist = [
    {
      label: '本科',
      value: '本科'
    },
    {
      label: '硕士研究生',
      value: '硕士研究生'
    },
    {
      label: '博士研究生',
      value: '博士研究生'
    },
    {
      label: '其它',
      value: '其它'
    }
  ];
  public uploadobj: any = {
    visible: false,
    filesXgzl: [],
    filesJjyj: [],
    handlefileSatisfy: []
  };
  public ruleForm: any = {
    filelist: [],
    fileid: '',
    visible: false,
    bhvisible: false
  };

  initData(): void {}
  // 课题组成员及在课题研究中承担的主要工作
  public dtJob: any = {
    sel: null, // 选中行
    columns: [
      { field: 'name', title: '姓名' },
      { field: 'work', title: '工作单位及职称' },
      { field: 'speciality', title: '专长' },
      { field: 'job', title: '承担的主要工作' },
      { field: 'workdate', title: '工作时间' }
    ],
    data: []
  };
  // 课题成果目录
  public dtTopicResult: any = {
    sel: null, // 选中行
    columns: [
      { field: 'name', title: '成果名称' },
      { field: 'form', title: '成果形式' },
      { field: 'author', title: '作者' },
      { field: 'remark', title: '备注' }
    ],
    data: []
  };
  // 经费数据
  public fundingdata: any = {
    sel: null, // 选中行
    id: '',
    columns: [
      { field: 'expense', title: '支出项目' },
      { field: 'description', title: '具体细目' },
      { field: 'money', title: '金额' }
    ],
    data: [
      {
        id: '',
        expense: '资料费',
        money: '0',
        money1: '0',
        description: ''
      },
      {
        id: '',
        expense: '办公费',
        money: '0',
        money1: '0',
        description: ''
      },
      {
        id: '',
        expense: '差旅费',
        money: '0',
        money1: '0',
        description: ''
      },
      {
        id: '',
        expense: '咨询费',
        money: '0',
        money1: '0',
        description: ''
      },
      {
        id: '',
        expense: '印刷费',
        money: '0',
        money1: '0',
        description: ''
      },
      {
        id: '',
        expense: '管理费',
        money: '0',
        money1: '0',
        description: ''
      },
      {
        id: '',
        expense: '其他经费',
        money: '0',
        money1: '0',
        description: ''
      },
      {
        id: '',
        expense: '合计',
        money: '0',
        money1: '0',
        description: ''
      }
    ],
    // 其他经费情况说明
    remark: '',
    // 立项批准经费
    lxpzdata: [
      {
        width: '830px',
        id: '',
        money: '0',
        money1: '0'
      }
    ],
    // 结余（超支）金额
    jydata: [
      {
        money: '0',
        money1: '0'
      }
    ]
  };
  // 生成预算表按钮等待配置项
  public madeobj = {
    btdisable: false,
    isGeting: false,
    count: 10,
    getCode: '生成报告',
    getYscode: '生成预算表',
    getRwsCode: '生成任务书'
  };
  // 课题附件上传
  public uploadData = [];
  mounted() {
    let topicparam = window.sessionStorage.getItem('topicid') as any
    this.baseurl = (window as any).baseurl
    if (JSON.parse(topicparam).topicId) {
      this.topicid = JSON.parse(topicparam).topicId
      if (this.topicid) {
        this.gettabledatinfo()
      }
    }
  }
  created() {}

  // @Watch("dataForm.topicname", { deep: true })
  // changeDfTopicname(nv, ov) {
  //   console.log(nv, ov);
  // }

  // #region 监听
  // 监听课题附件数组变化
  @Watch('uploadData')
  changektfjlist(newVal, oldVal) {
    if (newVal.length > 0) {
      this.uploadktfj = true
    } else {
      this.uploadktfj = false
    }
  }
  // 监听iswatch当前页面是否可编辑状态
  @Watch('iswatch')
  changeform11(newVal, oldVal) {
    if (newVal == false) {
      // let edit:any=this.editor["researchprogress"];
      // edit.setDisabled();
      $('.iseditys').css({ 'pointer-events': 'none' })
      $('.zcbtn').css({ display: 'none' })
      // 隐藏相关证书得上传和删除按钮
      $('.el-upload--picture-card').css({ display: 'none' })
    }
  }
  // #endregion

  leaveTabs(activeName, oldActiveName) {
    console.log(activeName, oldActiveName)
    this.getdataslist(activeName)
  }
  handleClick(val, index) {}
  // 获取对应标签数据
  getdataslist(activeName) {
    switch (activeName) {
      case '数据表':
        this.gettabledatinfo()
        break
      case '启动相关资料':
        this.getciterinfo('xgzl')
        break
      case '专家意见':
        this.getciterinfo('jjyj')
        break
      case '工作报告':
        this.editor['gzbgcontent'] = this.dataForm.jobcontent
        break
      case '技术成果报告':
        this.editor['jscgbgcontent'] = this.dataForm.technicalreporcontent
        break
      case '课题成果目录':
        break
      case '课题经费使用情况':
        break
      case '阶段评审意见':
      case '结题评审意见':
        this.editor['jdps1content'] = this.dataForm.stagereviewdepartmentcontent
        this.editor['jdps2content'] = this.dataForm.stagereviewexpertcontent
        break
      case '提交课题':
        this.getAccessorys(this)
        break
    }
  }

  // 暂存数据表内容
  savedatatable() {
    this.dataForm.isdelete = 0
    let params: any = window.sessionStorage.getItem('json')
    let params_: any = window.sessionStorage.getItem('topicid')
    if (JSON.parse(params_).topicId != null) {
      this.dataForm.topicid = JSON.parse(params_).topicId
    } else {
      if (JSON.parse(params_) != null) {
        this.dataForm.topicid = JSON.parse(params_)
      } else {
        this.$message.warning('个人信息失效，请重新登录')
        this.$router.push('/login')
        return false
      }
    }
    this.dataForm.userId = JSON.parse(params).data.id
    this.dataForm.state = 3 // 暂存得数据状态是3
    console.log(this.dtJob.data)
    if (this.dtJob.data.length != 0) {
      this.dtJob.data.forEach((res, index) => {
        if (String(res.id).length == 13) {
          res.id = ''
        }
        res.isset = 0
        res.seq = index + 1
      })
    }
    this.dataForm.topicLadderJobInfoList = this.dtJob.data
    this.dataForm.researchprogress = this.editor.researchprogress
    //
    // this.dataForm.technicalreporcontent = this.editor['jscgbgcontent']
    // this.dataForm.jobcontent = this.editor['gzbgcontent']
    // this.dataForm.stagereviewdepartmentcontent = this.editor['jdps1content']
    // this.dataForm.stagereviewexpertcontent = this.editor['jdps2content']

    console.log(this.dataForm);

    (this.$refs.dataForm as any).validate((valid) => {
      if (valid) {
        updateinfo(this.dataForm).then((res) => {
          if (res.code === 200) {
            this.$message.success('数据表数据暂存成功')
            this.gettabledatinfo()
          }
        })
      } else {
        return false
      }
    })
  }

  // #region 图片上传
  fileOnChange(file: any, fileList, type) {
    //  console.log(file, fileList,type);
    const isLt2M = file.size > 512000
    const filelength = fileList.length
    if (isLt2M) {
      this.$message.warning('上传图片大小不能超过 500k!')
      fileList.splice(-1, 1) // 移除选中图片
      return false
    } else {
      if (type == 'xgzl') this.uploadobj.filesXgzl.push(file)
      else if (type == 'jjyj') this.uploadobj.filesJjyj.push(file)
    }
  }
  handleClose() {
    this.uploadobj.visible = false
  }

  handlePictureCardPreview(file) {
    console.log(file)
    this.uploadobj.visible = true
    this.uploadobj.url = file.url
  }
  handleRemove(file, filelist, type) {
    if (type == 'xgzl') this.uploadobj.filesXgzl = filelist
    else if (type == 'jjyj') this.uploadobj.filesJjyj = filelist
  }
  // 暂存相关资料、专家意见
  savefiles(type) {
    let formdata: any = new FormData()
    let topiciid = ''
    let newarr: any = []
    let paramarr: any = []
    let bsfu = 0
    let content = ''

    let params: any = window.sessionStorage.getItem('json')
    let params_: any = window.sessionStorage.getItem('topicid')
    if (JSON.parse(params_).topicId != null) {
      this.dataForm.topicid = JSON.parse(params_).topicId
    } else {
      if (JSON.parse(params_) != null) {
        topiciid = JSON.parse(params_)
      } else {
        this.$message.warning('个人信息失效，请重新登录')
        this.$router.push('/login')
        return false
      }
    }
    var fileType = 0
    var uploadobjKey = ''
    var len = 0
    if (type == 'xgzl') {
      fileType = 0
      len = this.uploadobj.filesXgzl.length
      uploadobjKey = 'filesXgzl'
    } else if (type == 'jjyj') {
      fileType = 1
      len = this.uploadobj.filesJjyj.length
      uploadobjKey = 'filesJjyj'
    }

    if (len == 0) {
      this.$message.warning('当前未导入图片')
      return
    }
    this.loading = true
    this.uploadobj[uploadobjKey].forEach((res) => {
      if (res.raw) {
        formdata.append('file', res.raw)
        bsfu = 0
      } else {
        newarr.push(res)
        bsfu = 1
      }
    })

    newarr.forEach((res) => {
      let index = res.url.indexOf('=')
      let index_ = res.url.indexOf('&')
      paramarr.push(res.url.substring(index + 1, index_))
    })

    // 更新
    content = paramarr.join(',')
    if (content.length != 0) {
      let param = {
        id: this.uploadid,
        content: content
      }
      if (bsfu == 0) {
        updateuploadfile(param).then((res) => {
          if (res.code === 200) {
            formdata.append('tableType', 0)
            formdata.append('topicladderId', this.id)
            formdata.append('state', 3)
            formdata.append('id', this.uploadid)
            formdata.append('fileType', fileType)
            formdata.append('isdelete', 0)
            uploadzsxg(formdata).then((res) => {
              if (res.code == 200) {
                this.loading = false
                this.$message.success('证书上传成功')
                // (this.$refs.uploadzs as any).clearFiles();
                this.getciterinfo(type)
              }
            })
          }
        })
      } else if (bsfu == 1) {
        updateuploadfile(param).then((res) => {
          if (res.code == 200) {
            this.loading = false
            this.$message.success('证书上传成功')
            this.getciterinfo(type)
          }
        })
      }
    } else {
      formdata.append('tableType', 0)
      formdata.append('topicId', topiciid)
      formdata.append('state', 3)
      formdata.append('id', '')
      formdata.append('fileType', fileType)
      formdata.append('isdelete', 0)
      let param_ = {
        id: topiciid,
        fileType: fileType,
        content: ''
      }
      removefile(param_).then((res) => {
        uploadzsxg(formdata).then((res) => {
          if (res.code == 200) {
            this.loading = false
            this.$message.success('证书上传成功')
            this.getciterinfo(type)
          }
        })
      })
    }
  }
  // #endregion

  // 获取相关证书info接口
  getciterinfo(type) {
    type = type || ''
    let param = {
      topicladderid: this.id,
      filetype: 0
    }
    let uploadobjKey = ''
    if (type == 'xgzl') {
      uploadobjKey = 'filesXgzl';
      (this.$refs.uploadzl as any).clearFiles()
      param.filetype = 0
    } else if (type == 'jjyj') {
      uploadobjKey = 'filesJjyj';
      (this.$refs.uploadzjyj as any).clearFiles()
      param.filetype = 1
    }
    getfiles(param).then((res) => {
      if (res.code === 200) {
        if (res.data.id == null) {
          this.uploadid = ''
        } else {
          this.uploadid = res.data.id
        }
        let newArray: any = []
        res.data.picList.forEach((item) => {
          item = this.baseurl + item
          newArray.push({ url: item })
        })
        console.log(newArray)
        this.uploadobj[uploadobjKey] = newArray
        this.$nextTick(() => {
          if (!this.iswatch) {
            $('.el-upload-list__item-delete').css({ display: 'none' })
          }
        })
      }
    })
  }
  // 暂存富文本内容
  saveEditor(type) {
    let topiciid_ = ''
    let params_: any = window.sessionStorage.getItem('topicid')
    // console.log(JSON.parse(params_))
    if (JSON.parse(params_).topicId != null) {
      topiciid_ = JSON.parse(params_).topicId
    } else {
      if (JSON.parse(params_) != null) {
        topiciid_ = JSON.parse(params_)
      } else {
        this.$message.warning('个人信息失效，请重新登录')
        this.$router.push('/login')
        return false
      }
    }
    let param: any = {
      id: this.id,
      topicid: topiciid_,
      state: 3
    }
    // 工作报告
    if (type == 'UEeditorReport') {
      param.type = 0
      param.content = this.editor.gzbgcontent
      console.log(param)
      saveOrupdateContent(param).then((res) => {
        if (res.code === 200) {
          this.dataForm.jobcontent = this.editor['gzbgcontent']
          this.$message.success('工作报告暂存成功')
        }
      })
    }
    // 技术成果报告
    else if (type == 'UEeditorTechnicalReport') {
      param.type = 1
      param.content = this.editor.jscgbgcontent
      console.log(param)
      saveOrupdateContent(param).then((res) => {
        if (res.code === 200) {
          this.dataForm.technicalreporcontent = this.editor['jscgbgcontent']
          this.$message.success('技术成果报告暂存成功')
        }
      })
    }
    // 阶段评审意见
    else if (type == 'jdps') {
      param.type = 2
      param.content = this.editor.jdps1content
      param.content2 = this.editor.jdps2content
      console.log(param)
      saveOrupdateContent(param).then((res) => {
        if (res.code === 200) {
          this.dataForm.stagereviewdepartmentcontent = this.editor['jdps1content']
          this.dataForm.stagereviewexpertcontent = this.editor['jdps2content']
          this.$message.success('阶段评审意见暂存成功')
        }
      })
    }
  }
  // 暂存课题成果目录
  savektcgml() {
    let topiciid_ = ''
    let params_: any = window.sessionStorage.getItem('topicid')
    // console.log(JSON.parse(params_))
    if (JSON.parse(params_).topicId != null) {
      topiciid_ = JSON.parse(params_).topicId
    } else {
      if (JSON.parse(params_) != null) {
        topiciid_ = JSON.parse(params_)
      } else {
        this.$message.warning('个人信息失效，请重新登录')
        this.$router.push('/login')
        return false
      }
    }

    let param: any = {
      topicid: topiciid_,
      id: this.id,
      state: 3
    }
    if (this.dtTopicResult.data.length != 0) {
      this.dtTopicResult.data.forEach((res, index) => {
        if (String(res.id).length == 13) {
          res.id = ''
        }
        res.isset = 0
        res.seq = index + 1
      })
    }
    param.topicladderresultList = this.dtTopicResult.data
    param.topicLadderResultInfoDelIds =
      this.dataForm.topicLadderResultInfoDelIds
    console.log(param)
    updateTopicResult(param).then((res) => {
      if (res.code === 200) {
        this.$message.success('课题成果目录暂存成功')
        this.gettabledatinfo()
      }
    })
  }
  // 暂存课题经费使用情况
  savektjfsyqk() {
    let topiciid_ = ''
    let params_: any = window.sessionStorage.getItem('topicid')
    // console.log(JSON.parse(params_))
    if (JSON.parse(params_).topicId != null) {
      topiciid_ = JSON.parse(params_).topicId
    } else {
      if (JSON.parse(params_) != null) {
        topiciid_ = JSON.parse(params_)
      } else {
        this.$message.warning('个人信息失效，请重新登录')
        this.$router.push('/login')
        return false
      }
    }
    if (this.fundingdata.data.length != 0) {
      this.fundingdata.data.forEach((res, index) => {
        if (String(res.id).length == 13) {
          res.id = ''
        }
        res.isset = 0
        res.seq = index + 1
      })
    }
    let param: any = {
      id: this.dataForm.id,
      topicid: topiciid_,
      state: 3,
      otherexpensesremark: this.editor.fundingdatadesc,
      approvalfunds: this.fundingdata.lxpzdata[0].money,
      balanceamount: this.fundingdata.jydata[0].money,
      topicladderfundingList: this.fundingdata.data
    }
    console.log(param)
    updateTopicFunding(param).then((res) => {
      if (res.code === 200) {
        this.$message.success('课题经费使用情况暂存成功')
        this.gettabledatinfo()
      }
    })
  }

  // 生成报表
  createfile(type) {
    console.log('type', type)
    let title = ''
    let formadata = new FormData()
    formadata.append('topicId', this.topicid)
    formadata.append('id', this.id)
    formadata.append('typeidentifier', this.typeidentifier + '')
    // let params_: any = {
    //   topicId:this.topicid,
    //   id: this.id,
    //   typeidentifier: this.typeidentifier
    // }
    var countDown = setInterval(() => {
      if (this.madeobj.count < 1) {
        this.madeobj.isGeting = false
        this.madeobj.btdisable = false
        if (type === 'rw') {
          this.madeobj.getRwsCode = '生成任务书'
        } else {
          this.madeobj.getCode = '生成报告'
        }
        this.madeobj.count = 10
        clearInterval(countDown)
        console.log(1)
      } else {
        this.madeobj.isGeting = true
        this.madeobj.btdisable = true
        if (type === 'rw') {
          this.madeobj.getRwsCode = this.madeobj.count-- + 's后重发'
        } else {
          this.madeobj.getCode = this.madeobj.count-- + 's后重发'
        }
      }
    }, 1000)
    createReport(formadata).then((res) => {
      if (res.code == 200) {
        if (type === 'sb') {
          this.$alert(
            '已成功向服务器发送课题文档的生成请求，请稍后尝试点击“下载报告”按钮进行下载',
            '提示',
            {
              confirmButtonText: '确定'
            }
          )
        } else {
          this.$alert(
            '已成功向服务器发送课题文档的生成请求，请稍后尝试点击“下载任务书”按钮进行下载',
            '提示',
            {
              confirmButtonText: '确定'
            }
          )
        }
      }
    })
  }
  // 下载报表
  downReport(type_: any, action_: any) {
    let param = {
      topicladderid: this.id
    }
    let sbdata: any = {} // 申报对象集合
    getReport(param).then((res) => {
      console.log(res)
      let data_ = res.data
      if (res.code == 200) {
        // state 0未生成 1生成中 2已生成
        data_.forEach((res) => {
          // res.type=0 完整版pdf
          if (res.type == 0) {
            sbdata = res
          }
        })
        if (data_.length == 0) {
          this.$message.warning('请先点击"生成报告"按钮生成报告文档')
          return
        }
        if (type_ == 0) {
          if (sbdata.state == 1) {
            this.$message.warning('报告正在生成中,请稍后下载')
          } else if (sbdata.state == 2) {
            sbdata.url = sbdata.url.split(',').shift()
            // let href = (window as any).baseurl + "fileHp/pdfDownloadFile?fileName=" + sbdata.url;
            // let href = (window as any).baseurl + "pdf/" + sbdata.url;
            // let href = (window as any).baseurl + "pdfstate/downPdf?fileName=" + sbdata.url;
            let href = (window as any).downloadurl + '/pdf/' + sbdata.url
            if (action_ == 'xz') {
              this.downloadCommon(href, '结题报告')
            } else {
              window.open(href, '_blank')
            }
            //
            // console.log(href);
            // const savea = document.createElement("a");
            // if (action_ == "xz") savea.setAttribute("download", "结题报告");
            // else {
            //   savea.target = "_blank";
            // }
            // savea.href = href;
            // savea.click();
          }
        }
      }
    })
  }
  private async downloadCommon(url, fileNameStr = '文件') {
    try {
      // this.uploadLoading = true
      const response = await fetch(url, {
        method: 'GET'
      })

      const blob = await response.blob()
      const objectUrl = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = objectUrl

      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0') // 月份从0开始，需+1并补0
      const day = String(now.getDate()).padStart(2, '0')
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')

      // 从响应头读取后端设置的文件名
      const disposition = response.headers.get('Content-Disposition')
      let fileName = `${year}${month}${day}${hours}${minutes} ${fileNameStr}` // 初始文件名

      if (disposition) {
        // 匹配后端返回的 filename（兼容不同格式）
        const match = disposition.match(/filename="?([^";]+)"?/)
        if (match && match[1]) {
          fileName = decodeURIComponent(match[1])
        }
      }

      a.download = fileName
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(objectUrl) // 释放内存
    } catch (error) {
      this.$message.error('下载文件失败，请稍后重试')
    } finally {
      // this.uploadLoading = false
    }
  }
  // 上传报表
  uploadtopic(type) {
    if (type == 0) {
      this.ruleForm.visible = true
    } else {
      this.ruleForm.bhvisible = true
    }
    this.ruleForm.filelist = []
  }
  // #region 提交表单Tag
  // 提交表单
  submitrefuseform() {
    let param = {
      id: this.id
    }
    if (this.uploadData.length === 0) {
      this.$message.warning('请上传附件')
    } else {
      let param = {
        id: this.topicid,
        state: 21
      }
      updateStatus(param).then((res) => {
        if (res.code == 200) {
          this.$message.success('提交成功')
          this.gettabledatinfo()
        }
      })
    }
  }
  // 获取附件列表
  getAccessorys = (_this) => {
    // console.log("this.id",_this.dataForm)
    let param: any = {
      id: _this.id,
      fileType: 0
    }
    getAccessoryList(param).then((res) => {
      console.log(res)
      _this.uploadData = res.data.itemList
      _this.ruleForm.fileid = res.data.id
      if (_this.uploadData.length > 0) {
        _this.subisuse = false
        _this.subbtn = 'primary'
      }
    })
  };

  handlePreview(file) {}
  handleExceed(files, fileList) {
    console.log(files)
    this.$message.warning(`当前限制只允许上传 1 个文件`)
  }
  topicfilechange(file, filelist) {
    const isMaxsize = file.size / 1024 / 1024 < 200
    if (!isMaxsize) {
      this.$message.warning('文件大小不能超过200M')
      this.ruleForm.filelist = []
    } else {
      this.ruleForm.filelist.push(file)
    }
  }
  handleRemovetopic(file, fileList) {
    this.ruleForm.filelist = fileList
  }
  handleWatch(row) {
    let index = row.loadPath.indexOf('=')
    let index_ = row.loadPath.indexOf('&')
    row.loadPath = row.loadPath.substring(index + 1, index_)
    console.log(row, row.loadPath)
    let href = (window as any).downloadurl + '/pdf/' + row.loadPath
    const savea = document.createElement('a')
    savea.download = row.fileName
    savea.href = href
    savea.click()
  }
  handleDeletetopic(type, index, row) {
    this.$confirm('确定删除这条数据吗, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        if (type == 0) {
          this.uploadData.splice(index, 1)
          if (this.uploadData.length == 0) {
            this.subbtn = 'info'
            this.subisuse = true
          }
        } else {
          this.uploadData.splice(index, 1)
          this.subbtn = 'info'
          this.subisuse = true
        }
        let start = row.loadPath.indexOf('=')
        let end = row.loadPath.indexOf('&')
        row.loadPath = row.loadPath.substring(start + 1, end)
        let param = {
          fileName: row.fileName,
          filePath: row.loadPath,
          fileSize: row.fileSize,
          id: row.id,
          isdelete: 1
        }
        updatetopicfile(param).then((res) => {
          if (res.code === 200) {
            this.$message.success('删除成功')

            if (this.uploadData.length == 0) {
              // this.subysbtn = 'info'
              // this.subysisuse = true
            }
          }
        })
      })
      .catch(() => {})
  }
  handleDeleteystopic() {}
  uploadfile(type: number) {
    if (this.ruleForm.filelist.length == 0) {
      this.$message.warning('未选择文件，请选择后上传')
    } else {
      let ispdf = true
      let isPDF = true
      // 判断上传文件的类型
      // this.ruleForm.filelist.forEach((res) => {
      //   if (res.name.substring(res.name.lastIndexOf(".") + 1) == "pdf") {
      //     ispdf = true;
      //   } else if (res.name.substring(res.name.lastIndexOf(".") + 1) == "PDF") {
      //     isPDF = true;
      //   }
      // });
      if (ispdf || isPDF) {
        let formdata: any = new FormData()
        this.ruleForm.filelist.forEach((res: any) => {
          formdata.append('file', res.raw)
        })
        formdata.append('tableType', 1)
        // formdata.append("topicId", this.topicid);
        formdata.append('topicladderId', this.id)
        formdata.append('state', 3)
        formdata.append('isdelete', 0)
        formdata.append('id', this.uploadid)
        if (type == 0) {
          formdata.append('fileType', 0)
        } else {
          formdata.append('fileType', 1)
        }
        this.uploadloading = true
        uploadzsxg(formdata).then((res: any) => {
          if (res.code == 200) {
            this.uploadloading = false
            this.$message.success('课题附件上传成功')
            this.subbtn = 'primary'
            this.subisuse = false
            this.ruleForm.visible = false
            this.ruleForm.bhvisible = false
            this.getAccessorys(this)
          } else if (res.code == 201) {
            this.$message.warning('服务器出了小差,请刷新页面重新上传')
          }
        })
      } else {
        this.$message.warning('只允许上传pdf文件，请检查后重新上传')
      }
    }
  }
  // #endregion

  // 获取数据表内容
  gettabledatinfo() {
    let userinfo = {
      name: '',
      page: 1,
      limit: 10,
      typeidentifier: this.typeidentifier,
      topicId: this.topicid
    }
    console.log(userinfo)
    gettableinfo(userinfo).then((res: any) => {
      console.log(res)
      if (res.code === 200) {
        let data_ = res.data
        console.log('data', data_)
        if (data_) {
          this.dataForm = data_.topicladder
          this.iswatch = data_.topicState == '14'
          this.id = data_.topicladder.id
          this.dataForm.topicname = data_.topicname
          this.dataForm.topicnum = data_.topicnum
          this.dataForm.topicLadderJobInfoDelIds = []
          this.dataForm.topicLadderResultInfoDelIds = []
          this.editor.researchprogress = this.dataForm.researchprogress
          let cut = this.dataForm.topicnum.substring(0, 2)
          switch (cut) {
            case 'TA':
              this.dataForm.topictype = '重点'
              break
            case 'TB':
              this.dataForm.topictype = '一般'
              break
            case 'TC':
              this.dataForm.topictype = '立项不资助'
              break
            // case 'TD':
            //   this.dataForm.topictype = '委托'
            //   break
            case 'TE':
              this.dataForm.topictype = '青年专项'
              break
            default:
              this.dataForm.topictype = '委托'
              break
          }

          if (data_.topicladderjobList != null) { this.dtJob.data = data_.topicladderjobList }
          if (data_.topicladderresultList != null) { this.dtTopicResult.data = data_.topicladderresultList }
          if (this.dataForm.otherexpensesremark != null) { this.editor.fundingdatadesc = this.dataForm.otherexpensesremark }
          if (this.dataForm.approvalfunds != null) { this.fundingdata.lxpzdata[0].money = this.dataForm.approvalfunds }
          if (this.dataForm.balanceamount != null) { this.fundingdata.jydata[0].money = this.dataForm.balanceamount }
          if (data_.topicladderfundingList != null) {
            let a = this.fundingdata.data
            let b = data_.topicladderfundingList
            for (let i = 0; i < b.length; i++) {
              for (let j = 0; j < a.length; j++) {
                if (b[i].expense === a[j].expense) {
                  a[j].id = b[i].id
                  a[j].money = b[i].money
                  a[j].description = b[i].description
                }
              }
            }
          }
        }
      }
    })
  }

  public rules = {
    keyword: [
      { required: true, validator: this.validatePass2, trigger: 'blur' }
    ]
  };
  public validatePass2(rule, value, callback) {
    var arr = new Array()
    arr = value.split(' ')
    if (value === '') {
      callback(new Error('请输入关键词'))
    } else if (arr.length > 3) {
      callback(new Error('关键词不能超过三个(请检查是否多空格)'))
    } else {
      callback()
    }
  }
  /** **-----------------表格输入框处理方法开始------------------------*****/
  readMasterUser(dataresouce) {
    // 根据实际情况，自己改下啊
    this[dataresouce].data.map((i) => {
      i.id = i.id // 模拟后台插入成功后有了id
      i.isset = false // 给后台返回数据添加`isset`标识
      return i
    })
  }
  // 添加表格输入框input数据
  addMasterUser(dataresouce: any) {
    for (let i of this[dataresouce].data) {
      if (i.isset) return this.$message.warning('请先保存当前编辑项')
    }
    let j = {}
    if (dataresouce == 'dtJob') {
      j = {
        id: new Date().getTime(),
        name: '',
        work: '',
        speciality: '',
        job: '',
        workdate: '',
        isset: true
      }
    } else if (dataresouce == 'dtTopicResult') {
      j = {
        id: new Date().getTime(),
        name: '',
        form: '',
        author: '',
        remark: '',
        isset: true
      }
    }
    this[dataresouce].data.push(j)
    this[dataresouce].sel = JSON.parse(JSON.stringify(j))
  }
  // 修改表格输入框
  personChange(dataresouce, row, index, cg) {
    if (row.id.length == 0)
    // 点击修改 判断是否已经保存所有操作
    { row.id = new Date().getTime() }
    for (let i of this[dataresouce].data) {
      if (i.isset && i.id != row.id) {
        this.$message.warning('请先保存当前编辑项')
        return false
      }
    }
    // 是否是取消操作

    if (!cg) {
      if (String(this[dataresouce].sel.id).length === 13) {
        let copesource = _.clone(this[dataresouce].sel)
        delete copesource.id
        // delete copesource.isset;
        for (let i in copesource) {
          // console.log(copesource);
          if (copesource[i] === true) {
            this[dataresouce].data.splice(index, 1)
            return (row.isset = !row.isset)
          }
        }
      }

      // this[dataresouce].data.splice(index, 1);
    }
    // 提交数据
    if (row.isset) {
      if (this[dataresouce].data.length > 20) {
        this.$message.warning('当前最多添加20个')
      } else {
        // 项目是模拟请求操作  自己修改下
        let data = JSON.parse(JSON.stringify(this[dataresouce].sel))
        for (let k in data) row[k] = data[k]
        // 然后这边重新读取表格数据
        this.readMasterUser(dataresouce)
        row.isset = false
      }
    } else {
      this[dataresouce].sel = JSON.parse(JSON.stringify(row))
      row.isset = true
    }
  }

  // 删除表格输入框input表格方法
  handledelete(dataresouce, index) {
    this.$confirm('确定删除这条数据吗, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        if (dataresouce == 'dtJob') {
          const drow = this[dataresouce].data[index]
          if (drow.id.length > 13) {
            this.dataForm.topicLadderJobInfoDelIds.push(drow.id)
          }
        } else if (dataresouce == 'dtTopicResult') {
          const drow = this[dataresouce].data[index]
          if (drow.id.length > 13) {
            this.dataForm.topicLadderResultInfoDelIds.push(drow.id)
          }
        }
        this[dataresouce].data.splice(index, 1)
      })
      .catch(() => {})
  }

  // 修改经费属性
  editProperty(row, index, data_) {
    if (row.money == '') {
      row.money = 0
    }
    // 我这边是表格数据都是前端处理，需要把旧值存起来，用户点击修改之后修改了原来的数据，但是又点了取消的情况，还需要获取到原来的值
    sessionStorage.setItem('oldPropertValue', row.money)
    // // money为ture展示输入框
    this.$set(data_[index], 'isEditPropertyShow', true)
  }
  // 保存经费属性
  saveProperty(row, index, data_, type) {
    console.log(row)
    this.$set(data_[index], 'isEditPropertyShow', false)
    if (row.money == '') {
      row.money = 0
    } else if (row.money1 == '') {
      row.money1 = 0
    }
  }
  // 取消经费预算属性
  cancelProperty(row, index, data_) {
    if (sessionStorage.getItem('oldPropertValue') !== 'null') {
      this.$set(
        data_[index],
        'money',
        sessionStorage.getItem('oldPropertValue')
      )
    } else {
      this.$set(data_[index], 'money', 0)
    }
    this.$set(data_[index], 'isEditPropertyShow', false)
  }

  public editor = {
    id: '',
    researchprogress: '',
    gzbgcontent: '',
    jscgbgcontent: '',
    fundingdatadesc: '',
    jdps1content: '',
    jdps2content: ''
  };
  public ueConfig = {
    // 编辑器不自动被内容撑高
    autoHeightEnabled: false,
    // 初始容器高度
    initialFrameHeight: 595,
    // 初始容器宽度
    initialFrameWidth: 691,
    // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
    serverUrl: '',
    // UEditor 资源文件的存放路径，如果你使用的是 vue-cli2.0 生成的项目，通常不需要设置该选项，默认是：UEDITOR_HOME_URL: '/static/UEditor/'
    // 但是 vue cli 3.x 生成的项目中，默认值是 process.env.BASE_URL + 'UEditor/'，如果项目不是部署在根目录下，则需要自己配置路径，我的项目是在根目录下，手动下载的UEditor放在了public目录下
    UEDITOR_HOME_URL: '/ueditor/',
    // 自定义菜单
    toolbars: [
      [
        'undo', // 撤销
        'redo', // 重做
        'underline', // 下划线
        'strikethrough', // 删除线
        'fontborder', // 字符边框
        // "source", //源代码
        'subscript', // 下标
        'superscript', // 上标
        'formatmatch', // 格式刷
        'selectall', // 全选
        'preview', // 预览
        // "horizontal", //分隔线
        'cleardoc', // 清空文档
        'indent', // 首行缩进
        'bold', // 加粗
        'italic', // 斜体
        'fontfamily', // 字体
        'fontsize', // 字号
        'paragraph', // 段落格式
        'pagebreak', // 分页
        'insertframe', // 插入Iframe
        'searchreplace', // 查询替换
        'justifyleft', // 居左对齐
        'justifyright', // 居右对齐
        'justifycenter', // 居中对齐
        'justifyjustify', // 两端对齐
        'forecolor', // 字体颜色
        'backcolor', // 背景色
        'insertorderedlist', // 有序列表
        'insertunorderedlist', // 无序列表
        // "fullscreen", //全屏
        'directionalityltr', // 从左向右输入
        'directionalityrtl', // 从右向左输入
        'rowspacingtop', // 段前距
        'rowspacingbottom', // 段后距
        'imagenone', // 默认
        'imageleft', // 左浮动
        'imageright', // 右浮动
        // "attachment", //附件
        'imagecenter', // 居中
        'lineheight', // 行间距
        'edittip ', // 编辑提示
        // "customstyle", //自定义标题
        // "autotypeset", //自动排版
        'tolowercase', // 字母小写
        'inserttable', // 插入表格
        'charts' // 图表
      ]
    ]
  };

  public getConfig(len) {
    let uc = JSON.parse(JSON.stringify(this.ueConfig))
    if (Number(len) > 0) {
      uc.maximumWords = len
    }
    return uc
  }
  // unditor加载完成
  public UEeditorReport(editor) {
    let isdisabled = this.iswatch
    if (editor != null) {
      //  this.editorgzbgcontent = editor
      if (!isdisabled) {
        editor.setDisabled()
      }
    }
  }

  // unditor加载完成
  public UEeditorTechnicalReport(editor) {
    let isdisabled = this.iswatch
    if (editor != null) {
      //  this.editorjscgbgcontent = editor
      if (!isdisabled) {
        editor.setDisabled()
      }
    }
  }
}
